// main tools
import { useRef } from 'react'

// components
import { ConfirmDialog } from '@centria-ui-atoms/confirm-dialog'

// prime components
import { ConfirmDialog as PrConfirmDialog } from 'primereact/confirmdialog'
import { ScrollTop } from 'primereact/scrolltop'
import { Toast } from 'primereact/toast'

// context
import { AppContext } from './context'

// types
import type { ConfirmDialogProps } from 'primereact/confirmdialog'
import type { FC, ReactNode } from 'react'

type AppContextProviderProps = {
  children: ReactNode
}

export const AppContextProvider: FC<AppContextProviderProps> = ({
  children
}) => {
  const toast = useRef<Toast>(null)

  const context = {
    toast: () => toast.current as Toast,
    confirmDialog: (options: ConfirmDialogProps) => ConfirmDialog(options)
  }

  return (
    <AppContext.Provider value={context}>
      {children}
      <PrConfirmDialog />
      <ScrollTop className='scroll-top' />
      <Toast ref={toast} position='top-right' />
    </AppContext.Provider>
  )
}
